export default "__VITE_ASSET__ece8d9df__"